import { createFileRoute } from '@tanstack/react-router';
import { prefetch } from '@/app/prefetch';
import { publicIdParam, resolveWorkspace } from '@/app/route-ids';
import { WorkspaceLayout } from '@/features/shell/workspace-layout';

/**
 * `/w/:workspace`: everything inside one workspace; the address names only the workspace. The
 * organization comes from the person's workspaces; children read both from the route context.
 */
export const Route = createFileRoute('/_app/w/$workspaceId')({
    params: publicIdParam('workspaceId'),
    beforeLoad: async ({ context, params, location }) => ({
        workspaceScope: await resolveWorkspace(context.queryClient, params.workspaceId, location),
    }),
    loader: ({ context }) => prefetch.workspace(context.queryClient, context.workspaceScope),
    component: function WorkspaceRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        return <WorkspaceLayout organizationId={organizationId} workspaceId={workspaceId} />;
    },
});
